<template>
    <Fragment>
        <Descriptions
            bordered
            :column="2"
        >
            <DescriptionsItem :label="$t('engine')">
                {{ measure.engine }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('estimator')">
                {{ measure.settings.model }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('selection')">
                {{ measure.settings.selectionMethod }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('objective')">
                {{ measure.objective }}
            </DescriptionsItem>
        </Descriptions>
        <Descriptions
            bordered
            :title="$t('startingRules')"
            :column="2"
            class="mt-4"
        >
            <DescriptionsItem :label="$t('minimumNumberOfItems')">
                {{ measure.settings.minimumQuestionsAsked }}
            </DescriptionsItem>
            <DescriptionsItem :label="$t('type')">
                {{ measure.startingRulesType }}
            </DescriptionsItem>
        </Descriptions>
    </Fragment>
</template>

<script>
import { Descriptions } from 'ant-design-vue';
export default {
    name: 'CAT',
    components: {
        Descriptions,
        DescriptionsItem: Descriptions.Item,
    },
    props: {
        measure: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style>

</style>